import styled from 'styled-components';
import { PossibleCompetitorRankingDistribution } from 'services/actions/ai_management_possible_competitors';
import colors from 'styles/colors';

type Theme = typeof colors;

const barColor = (theme: Theme, bucket: keyof PossibleCompetitorRankingDistribution) =>
  ({
    primeiro: theme.$blue800,
    segundo_terceiro: theme.$blue600,
    quarto_decimo: theme.$blue400,
    acima_decimo: theme.$blue300,
    sem_classificacao: theme.$gray500,
  }[bucket]);

export const Distribution = styled.div`
  .distribution-row {
    display: grid;
    grid-template-columns: minmax(120px, 160px) 1fr 56px;
    gap: 16px;
    align-items: center;
    margin-bottom: 14px;
    font-size: 15px;
    color: ${(props) => props.theme.$dark};

    &:last-child {
      margin-bottom: 0;
    }
  }

  .distribution-track {
    height: 24px;
    border-radius: 12px;
    background: ${(props) => props.theme.$gray200};
    overflow: hidden;
  }

  .distribution-value {
    text-align: right;
    font-variant-numeric: tabular-nums;
  }
`;

export const Bar = styled.div<{
  $share: number;
  $bucket: keyof PossibleCompetitorRankingDistribution;
}>`
  width: ${(props) => props.$share}%;
  min-width: ${(props) => (props.$share > 0 ? '8px' : '0')};
  height: 100%;
  border-radius: 12px;
  background: ${(props) => barColor(props.theme, props.$bucket)};
  transition: width 0.3s ease;
`;
